<!--
 * @Description: 
 * @Author: xiong.zhou@dmall.com
 * @Date: 2022-05-09 23:59:34
 * @LastEditors: xiong.zhou@dmall.com
 * @LastEditTime: 2022-05-21 22:19:28
-->
<template>
    <div class="login-wrapper">
        <main class="login-wrapper__main">
            <div class="logo">
                <img src="../../assets/images/login-logo.png" @click="handleLogo">
            </div>
            <div class="content">
                <router-view></router-view>
            </div>
        </main>
    </div>
</template>

<script>
export default {
    name: 'LoginPage',
    data() {
        return {
            status: 0
        };
    },
    methods: {
        handleLogo() {
            this.$router.push({ name: 'Home' });
        }
    }
}
</script>

<style lang="scss" scoped>
.login-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
    background: #15161c url('/static/images/login_bg.png') center no-repeat;
    background-size: 100%;

    &__main {
        position: absolute;
        top: 46%;
        left: 29%;
        z-index: 1;
        transform: translate(-50%, -50%);
        width: 400px;
        box-sizing: border-box;
        overflow: hidden;

        .content {
            background: #fff;
            border-radius: 20px;
            padding: 36px 40px;
        }

        .logo {
            margin-bottom: 50px;
            text-align: center;

            img {
                width: 261px;
                height: 86px;
                cursor: pointer;
            }
        }
    }
}
</style>
